/*
 * Employee Leave Records
 */
import React from "react";
import { useState, useEffect } from "react";
import MetaTags from "react-meta-tags";
import {
  Col,
  Row,
  Button,
  Input,
  Select,
  DatePicker,
  Table,
  Typography,
  Checkbox,
  Modal,
  Badge,
} from "antd";
import { isEmpty } from "lodash";
import {
  FilterOutlined,
  ReloadOutlined,
  DownloadOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import { ToastContainer } from "react-toastify";
import "../Dashboard/index.css";
import "../EmployeeManagement/index.css";
import BreadcrumbComponent from "../../components/BreadCrumb";
import { useDispatch, useSelector } from "react-redux";
import api from "../../helpers";
// import moment from "moment";
import * as reportAction from "../../store/Reports/actions";
import { ReactSearchAutocomplete } from "react-search-autocomplete";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
//bread crumb
const BCrumb = [{ to: "/", title: "Home" }, { title: "Employee Leave Record" }];

const EmployeeLeaveRecord = () => {
  const [searchLoading, setSearchLoading] = useState(false);
  const [resetLoading, setResetLoading] = useState(false);
  const [filterEmployee, setFilterEmployee] = useState([]);
  const [filterEmployeeClear, setFilterEmployeeClear] = useState(false);
  const [downloadLoader, setDownloadLoader] = useState(false);

  const [documentData, setDocumentData] = useState([]);
  const [modalTitle, setModalTitle] = useState("");

  const [isModalVisible, setIsModalVisible] = useState(false);

  const update = useSelector((state) => state.Reports);
  const {
    dropDownList = {},
    employeeLeaveRecord_list = [],
    // documentList = [],
  } = update;

  dayjs.extend(utc);

  //filter initial data
  const [employeeLeaveData, setEmployeeLeaveData] = useState({
    employeeCode: "",
    fromDate: dayjs().startOf("month"),
    toDate: dayjs(),
    reason: "",
    count: "",
    countError: "", //
  });

  const fuseOptions = {
    keys: ["employeeCode", "label"],
  };

  //checkobox
  const [inactiveEmployees, setInActiveEmployees] = useState();
  const handleCheckboxChange = (e) => {
    if (e.target.checked) {
      setInActiveEmployees(true);
    } else {
      setInActiveEmployees("");
    }
  };

  //filter dropdown initial value
  const [department, setDepartment] = useState([]);
  const [designation, setDesignation] = useState([]);
  const calculateDateDiff = (from, to) => {
    return dayjs(to).diff(dayjs(from), "day") + 1; // +1 to include both start and end dates
  };

  //filter input handler
  const handleChange = (e) => {
    const { name, value } = e.target;
    let updatedData = { ...employeeLeaveData, [name]: value };

    if (name === "count") {
      const actualCount = calculateDateDiff(
        dayjs(employeeLeaveData.fromDate),
        dayjs(employeeLeaveData.toDate)
      );
      if (parseInt(value) >= actualCount) {
        updatedData.countError = `Count should be 1 to ${actualCount}`;
      } else {
        updatedData.countError = "";
      }
    }

    setEmployeeLeaveData(updatedData);
  };

  //searchInput
  const [searchInput, setSearchInput] = useState("");
  const [searchValue, setSearchValue] = useState({
    limit: 10,
    page: 1,
    fromDate: employeeLeaveData.fromDate,
    toDate: employeeLeaveData.toDate,
  });

  const specificDispatch = useDispatch();
  const dispatch = useDispatch();
  useEffect(() => {
    specificDispatch(
      reportAction.loadEmployeeLeaveRecord({
        limit: 10,
        page: 1,
        fromDate: employeeLeaveData.fromDate,
        toDate: employeeLeaveData.toDate,
      })
    );
    specificDispatch(reportAction.loadEmployeeDropdown());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [specificDispatch]);

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(employeeLeaveRecord_list?.total); // get this from your API response

  useEffect(() => {
    if (employeeLeaveRecord_list) {
      setTotalCount(employeeLeaveRecord_list?.total); // total is total count of records in the backend
    }
  }, [employeeLeaveRecord_list]);

  //filter functionality

  const handleFilter = (e) => {
    if (employeeLeaveData.countError && employeeLeaveData.countError !== "") {
      return;
    }
    e.preventDefault();
    setSearchLoading(true);

    setTimeout(() => {
      setSearchLoading(false);
    }, 500);
    let searchFilter = {};
    searchFilter.limit = pageSize;
    searchFilter.page = currentPage;
    if (employeeLeaveData.fromDate)
      searchFilter.fromDate = employeeLeaveData.fromDate.format("YYYY-MM-DD");
    if (employeeLeaveData.toDate)
      searchFilter.toDate = employeeLeaveData.toDate.format("YYYY-MM-DD");
    if (!isEmpty(filterEmployee))
      searchFilter.employeeCode = filterEmployee?.value;
    if (!isEmpty(department)) searchFilter.departmentId = department.value;
    if (!isEmpty(designation)) searchFilter.designationId = designation.value;
    if (inactiveEmployees) searchFilter.inactiveEmployees = inactiveEmployees;

    setSearchValue(searchFilter);

    //dispatch

    if (!isEmpty(searchFilter)) {
      dispatch(reportAction.loadEmployeeLeaveRecord(searchFilter));
    } else {
      dispatch(
        reportAction.loadEmployeeLeaveRecord({
          limit: 10,
          page: 1,
          fromDate: employeeLeaveData.fromDate,
          toDate: employeeLeaveData.toDate,
        })
      );
    }
  };

  const handleCount = (e) => {
    e.preventDefault();
    if (employeeLeaveData.countError && employeeLeaveData.countError !== "") {
      return;
    }
    setSearchLoading(true);

    setTimeout(() => {
      setSearchLoading(false);
    }, 500);
    let searchFilter = {};
    searchFilter.limit = pageSize;
    searchFilter.page = currentPage;
    if (employeeLeaveData.fromDate)
      searchFilter.fromDate = employeeLeaveData.fromDate.format("YYYY-MM-DD");
    if (employeeLeaveData.toDate)
      searchFilter.toDate = employeeLeaveData.toDate.format("YYYY-MM-DD");
    if (!isEmpty(filterEmployee))
      searchFilter.employeeCode = filterEmployee?.value;
    if (!isEmpty(department)) searchFilter.departmentId = department.value;
    if (!isEmpty(designation)) searchFilter.designationId = designation.value;
    if (inactiveEmployees) searchFilter.inactiveEmployees = inactiveEmployees;
    if (employeeLeaveData.count) searchFilter.count = employeeLeaveData.count;
    setSearchValue(searchFilter);

    //dispatch

    if (!isEmpty(searchFilter)) {
      dispatch(reportAction.loadEmployeeLeaveRecord(searchFilter));
    } else {
      dispatch(
        reportAction.loadEmployeeLeaveRecord({
          limit: 10,
          page: 1,
          fromDate: employeeLeaveData.fromDate,
          toDate: employeeLeaveData.toDate,
        })
      );
    }
  };
  //filter date handler
  const handleDateChange = (name, value) => {
    setEmployeeLeaveData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  //filter reset functionality
  const onReset = () => {
    setSearchInput("");
    setSearchValue({
      limit: 10,
      page: 1,
    });
    setResetLoading(true);
    setTimeout(() => {
      setEmployeeLeaveData({
        employeeCode: "",
        fromDate: dayjs().startOf("month"),
        toDate: dayjs(),
        reason: "",
        count: "",
        countError: "", //
      });
      setFilterEmployeeClear(true);
      setTimeout(() => {
        setFilterEmployeeClear(false);
      }, 0);
      setDepartment([]);
      setDesignation([]);
      setInActiveEmployees("");
      setResetLoading(false);
    }, 1000);
    dispatch(
      reportAction.loadEmployeeLeaveRecord({
        limit: 10,
        page: 1,
        fromDate: employeeLeaveData.fromDate,
        toDate: employeeLeaveData.toDate,
      })
    );
  };

  //table colums
  const [isPermission, setIsPermission] = useState(false);
  const [isLop, setIsLop] = useState(false);
  const columns = [
    {
      title: (
        <span style={{ whiteSpace: "nowrap" }} className="poppins-txt">
          S.No
        </span>
      ),
      dataIndex: "sno",
      width: 70,
      className: "poppins-txt-lg",
      sorter: (a, b) => a.sno - b.sno,
    },
    {
      title: (
        <span style={{ whiteSpace: "nowrap" }} className="poppins-txt">
          Employee Code
        </span>
      ),
      dataIndex: "employeeCode",
      width: 160,
      className: "poppins-txt-lg",
      sorter: (a, b) => a.employeeCode.localeCompare(b.employeeCode),
    },
    {
      title: "Employee Name",
      dataIndex: "employeeName",
      className: "poppins-txt-lg",
      sorter: (a, b) => a.employeeName.localeCompare(b.employeeName),
    },
    {
      title: "Department",
      dataIndex: "department",
      className: "poppins-txt-lg",
      sorter: (a, b) => a.department.localeCompare(b.department),
    },
    {
      title: "Designation",
      dataIndex: "designation",
      className: "poppins-txt-lg",
      sorter: (a, b) => a.designation.localeCompare(b.designation),
    },
    {
      title: "CL",
      dataIndex: "cl",
      className: "poppins-txt-lg",
      sorter: (a, b) => a.cl.localeCompare(b.cl),
      render: (text, data) => (
        <span
          style={{
            cursor: "pointer",
            color: "#e40d8c",
            textDecoration: "underline",
          }}
          onClick={() => {
            setDocumentData(data.clDetail);
            showModalOpen();
            setIsPermission(false);
            setIsLop(false);
            setModalTitle("CL Details");
          }}
        >
          {text}
        </span>
      ),
    },
    {
      title: "SL",
      dataIndex: "sl",
      className: "poppins-txt-lg",
      sorter: (a, b) => a.sl.localeCompare(b.sl),
      render: (text, data) => (
        <span
          style={{
            cursor: "pointer",
            color: "#e40d8c",
            textDecoration: "underline",
          }}
          onClick={() => {
            setDocumentData(data.slDetail);
            showModalOpen();
            setIsPermission(false);
            setIsLop(false);
            setModalTitle("SL Details");
          }}
        >
          {text}
        </span>
      ),
    },
    {
      title: "GL",
      dataIndex: "gl",
      className: "poppins-txt-lg",
      sorter: (a, b) => a.gl.localeCompare(b.gl),
      render: (text, data) => (
        <span
          style={{
            cursor: "pointer",
            color: "#e40d8c",
            textDecoration: "underline",
          }}
          onClick={() => {
            setDocumentData(data.glDetail);
            showModalOpen();
            setIsPermission(false);
            setIsLop(false);
            setModalTitle("GL Details");
          }}
        >
          {text}
        </span>
      ),
    },
    {
      title: "Permission Count",
      dataIndex: "permissionCount",
      className: "poppins-txt-lg",
      sorter: (a, b) => a.permissionCount - b.permissionCount,
      render: (text, data) => (
        <span
          style={{
            cursor: "pointer",
            color: "#e40d8c",
            textDecoration: "underline",
          }}
          onClick={() => {
            setDocumentData(data.permissionDetails);
            showModalOpen();
            setIsPermission(true);
            setIsLop(false);
            setModalTitle("Permission Details");
          }}
        >
          {text}
        </span>
      ),
    },
    {
      title: "LOP",
      dataIndex: "lopCount",
      className: "poppins-txt-lg",
      sorter: (a, b) => a.leaveCount.localeCompare(b.leaveCount),
      render: (text, data) => (
        <span
          style={{
            cursor: "pointer",
            color: "#e40d8c",
            textDecoration: "underline",
          }}
          onClick={() => {
            setDocumentData(data.lopDetails);
            setIsModalVisible(true);
            setIsPermission(false);
            setIsLop(true);
            setModalTitle("LOP Details");
          }}
        >
          {text}
        </span>
      ),
    },
    {
      title: "Working Days",
      dataIndex: "workingDays",
      className: "poppins-txt-lg",
      sorter: (a, b) => a.workingDays - b.workingDays,
    },
  ];
  const tableData = !isEmpty(employeeLeaveRecord_list.data)
    ? employeeLeaveRecord_list.data.map((data, index) => {
        const lopHrs = data && data.lopDetails;
        const totalLopHours = lopHrs.reduce((total, item) => {
          // Extract the numeric part from lopHours string
          const hours = parseFloat(item.lopHours);
          return total + (isNaN(hours) ? 0 : hours);
        }, 0);

        return {
          _id: data._id,
          sno: index + 1,
          employeeName:
            data.employeeId?.employeeName || data.employeeName || "--",
          employeeCode:
            data.employeeId?.employeeCode || data.employeeCode || "--",
          department: data.employeeId?.departmentId?.departmentName || "--",
          departmentName: data.employeeId?.departmentId?.departmentName || "",
          designation: data.employeeId?.designationId?.designationName || "--",
          cl: data.cl,
          sl: data.sl,
          gl: data.gl,
          permissionCount: data.permissionCount,
          leaveCount: data.leaveCount || "--",
          balancePermission: data.balancePermission || "--",
          workingDays: data.totalLeaveDeduction || "--",
          permissionDetails: data.permissionDetails,
          clDetail: data.clDetail,
          slDetail: data.slDetail,
          glDetail: data.glDetail,
          totalLeaveDoc: data.totalLeaveDoc,
          lopDetails: data.lopDetails,
          lopCount: data.lopCount
            ? `${data.lopCount}  (${totalLopHours} Hrs)`
            : 0,
        };
      })
    : [];

  const documentTable = !isEmpty(documentData)
    ? documentData.map((item, index) => ({
        key: index + 1,
        sno: index + 1,
        leaveFromDate: item.fromDate
          ? dayjs(item.fromDate).format("DD-MM-YYYY")
          : "--",
        leaveToDate: item.toDate
          ? dayjs.utc(item.toDate).format("DD-MM-YYYY")
          : "--",
        approvedBy: item?.approvedBy?.employeeName || item?.approvedBy || "--",
        attachment: item.attachment || "",
        approvedDate: item.approvedOn
          ? dayjs(item.approvedOn).format("DD-MM-YYYY")
          : "--",
        premisssionDate: item.dateOfPermission
          ? dayjs.utc(item.dateOfPermission).format("DD-MM-YYYY")
          : "--",
        fromHours: item.fromHours || "--",
        toHours: item.toHours || "--",
        reason: item.reason || "--",
        leaveMode: item.leaveMode || "--",
        status: item.PermissionStatus || "--",
        leaveStatus: item.leaveStatus || "--",
        permissionHours: item.permissionHours || "--",
        lopDate: item.lopDate ? dayjs(item.lopDate).format("DD-MM-YYYY") : "--",
        lopHours: item.lopHours || "--",
        absentType: item.absentType || "--",
        lopStatus: item.lopStatus || "--",
      }))
    : [];

  const documentColumns = [
    {
      title: (
        <span style={{ whiteSpace: "nowrap" }} className="poppins-txt">
          S.No
        </span>
      ),
      dataIndex: "sno",
      width: 70,
      className: "poppins-txt-lg",
    },
    {
      title: "Leave From Date",
      dataIndex: "leaveFromDate",
      className: "poppins-txt-lg",
      hidden: isPermission || isLop,
    },
    {
      title: "Leave To Date",
      dataIndex: "leaveToDate",
      className: "poppins-txt-lg",
      hidden: isPermission || isLop,
    },
    {
      title: "Date",
      dataIndex: "lopDate",
      className: "poppins-txt-lg",
      hidden: isPermission || !isLop,
    },
    {
      title: "Permission Date",
      dataIndex: "premisssionDate",
      className: "poppins-txt-lg",
      hidden: !isPermission,
    },
    {
      title: "From Hours",
      dataIndex: "fromHours",
      className: "poppins-txt-lg",
      hidden: !isPermission,
    },
    {
      title: "Leave Mode",
      dataIndex: "leaveMode",
      className: "poppins-txt-lg",
      hidden: isPermission || isLop,
    },
    {
      title: "To Hours",
      dataIndex: "toHours",
      className: "poppins-txt-lg",
      hidden: !isPermission,
    },
    {
      title: "Permission Hrs",
      dataIndex: "permissionHours",
      className: "poppins-txt-lg",
      hidden: !isPermission,
    },
    {
      title: "LOP Hours",
      dataIndex: "lopHours",
      className: "poppins-txt-lg",
      hidden: isPermission || !isLop,
    },
    {
      title: "Approved By",
      dataIndex: "approvedBy",
      className: "poppins-txt-lg",
    },
    {
      title: "Approved Date",
      dataIndex: "approvedDate",
      className: "poppins-txt-lg",
    },
    {
      title: "Reason",
      dataIndex: "reason",
      className: "poppins-txt-lg",
    },
    {
      title: "Absent Type",
      dataIndex: "absentType",
      className: "poppins-txt-lg",
      hidden: isPermission || !isLop,
    },
    {
      title: "Status",
      dataIndex: "lopStatus",
      className: "poppins-txt-lg",
      hidden: !isLop,
      render: (text, record) => {
        const status = isLop ? record.lopStatus : "--";

        let color =
          status === "Pending"
            ? "#f46a6a"
            : status === "Approved"
            ? "#34c38f"
            : "#f46a6a";
        return (
          <div className="flex items-center justify-center">
            <Badge
              count={status}
              style={{
                backgroundColor: color,
                color: "#fff",
                padding: "0 8px",
                height: "24px",
                lineHeight: "24px",
                display: "flex",
                alignItems: "center",
              }}
            />
          </div>
        );
      },
    },

    {
      title: "Attachment",
      dataIndex: "attachment",
      className: "poppins-txt-lg",
      hidden: isPermission || isLop,
      render: (text, record) =>
        record.attachment ? (
          <a
            href={record.attachment}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "blue", textDecoration: "underline" }}
          >
            View
          </a>
        ) : (
          "--"
        ),
    },
    {
      title: "Status",
      dataIndex: "leaveStatus",
      className: "poppins-txt-lg",
      hidden: isLop,
      render: (text, record) => {
        const status = isPermission ? record.status : record.leaveStatus;

        let color =
          status === "Pending"
            ? "#f46a6a"
            : status === "Approved"
            ? "#34c38f"
            : "#f46a6a";
        return (
          <div className="flex items-center justify-center">
            <Badge
              count={status}
              style={{
                backgroundColor: color,
                color: "#fff",
                padding: "0 8px",
                height: "24px",
                lineHeight: "24px",
                display: "flex",
                alignItems: "center",
              }}
            />
          </div>
        );
      },
    },
  ];
  //window height/width
  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    setTimeout(() => {}, 1500);

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const showModalOpen = () => {
    setIsModalVisible(true);
    // clearModelData();
  };

  const handleModalClose = () => {
    setIsModalVisible(false);
    setDocumentData([]);
  };

  //download functionlity
  const downloadFile = ({ data, fileName, fileType }) => {
    const blob = new Blob([data], { type: fileType });

    const a = document.createElement("a");
    a.download = fileName;
    a.href = window.URL.createObjectURL(blob);
    const clickEvt = new MouseEvent("click", {
      view: window,
      bubbles: true,
      cancelable: true,
    });
    a.dispatchEvent(clickEvt);
    a.remove();
  };

  const exportToCsv = async () => {
    setDownloadLoader(true);
    let searchFilter = {};
    if (employeeLeaveData.fromDate)
      searchFilter.joinDate = employeeLeaveData.fromDate.format("YYYY-MM-DD");
    if (employeeLeaveData.joinToDate)
      searchFilter.toDate = employeeLeaveData.toDate.format("YYYY-MM-DD");
    if (!isEmpty(filterEmployee))
      searchFilter.employeeCode = filterEmployee?.value;
    if (!isEmpty(department)) searchFilter.departmentId = department;
    if (!isEmpty(designation)) searchFilter.designationId = designation;
    if (inactiveEmployees) searchFilter.inactiveEmployees = inactiveEmployees;

    try {
      const res = await api.post("/auth/getleavereport", searchFilter);
      const employees = res.data?.data || [];

      const mappedData = employees.map((data, index) => {
        const lopHrs = data && data.lopDetails;
        const totalLopHours = lopHrs.reduce((total, item) => {
          // Extract the numeric part from lopHours string
          const hours = parseFloat(item.lopHours);
          return total + (isNaN(hours) ? 0 : hours);
        }, 0);
        return {
          _id: data._id,
          sno: index + 1,
          employeeName:
            data.employeeId?.employeeName || data.employeeName || "--",
          employeeCode:
            data.employeeId?.employeeCode || data.employeeCode || "--",
          department: data.employeeId?.departmentId?.departmentName || "--",
          departmentName: data.employeeId?.departmentId?.departmentName || "",
          designation: data.employeeId?.designationId?.designationName || "--",
          cl: data.cl || "--",
          sl: data.sl || "--",
          gl: data.gl || "--",
          permissionCount: data.permissionCount || "--",
          leaveCount: data.leaveCount || "--",
          balancePermission: data.balancePermission || "--",
          workingDays: data.totalLeaveDeduction || "--",
          lopCount: data.lopCount
            ? `${data.lopCount}  (${totalLopHours} Hrs)`
            : 0,
        };
      });

      // Only include fields for CSV that you want:
      const headers = [
        "S.No",
        "Employee Code",
        "Employee Name",
        "Department",
        "Designation",
        "CL",
        "SL",
        "GL",
        "Permission Count",
        "LOP Count",

        "Working Days",
      ];

      const csvRows = mappedData.map((item) => [
        item.sno,
        item.employeeCode,
        item.employeeName,
        item.department,
        item.designation,
        item.cl,
        item.sl,
        item.gl,
        item.permissionCount,
        item.lopCount,
        item.workingDays,
      ]);

      const csvContent = [
        headers.join(","),
        ...csvRows.map((row) => row.join(",")),
      ].join("\n");

      downloadFile({
        data: csvContent,
        fileName: "employee_Leave_record.csv",
        fileType: "text/csv",
      });
    } catch (error) {
      if (error) {
        setDownloadLoader(false);
      }
    } finally {
      setDownloadLoader(false);
    }
  };

  // search
  const handleSearch = () => {
    const payload = {
      search: searchInput,
    };
    setSearchLoading(true);

    setTimeout(() => {
      setSearchLoading(false);
    }, 500);
    dispatch(reportAction.loadEmployeeLeaveRecord(payload));
  };
  const designationOptions = !isEmpty(dropDownList.designationOptions)
    ? dropDownList.designationOptions.filter(
        (item) => item.departmentId === department.value
      )
    : [];

  return (
    <React.Fragment>
      <div className="pl-5">
        <MetaTags>
          <title>Employee Leave Record | Mequals</title>
        </MetaTags>
      </div>

      <Row justify="space-between" className="mr-4">
        <Col>
          <BreadcrumbComponent title="Employee Leave Record" items={BCrumb} />
        </Col>
      </Row>

      <div
        style={{
          background: "#ffffff",
          margin: "4px 8px 4px 8px", // top, right, bottom, left
          padding: "16px",
          borderRadius: "8px 8px 0px 0px",
        }}
      >
        <Row gutter={[16, 16]} style={{ marginTop: "2px" }}>
          <Col xs={24} sm={12} md={8} lg={6} xl={6}>
            <div className="mb-2">
              <Typography className="poppins-txt">Employee Code</Typography>
            </div>
            <ReactSearchAutocomplete
              name="filterEmployee"
              key={filterEmployeeClear}
              items={
                dropDownList.employeeOptions ? dropDownList.employeeOptions : []
              }
              value={filterEmployee}
              type="autoComplete"
              resultStringKeyName="label"
              showIcon={false}
              onChange={(e) => {
                setFilterEmployee(e.target.value);
              }}
              onSelect={(item) => {
                setFilterEmployee(item);
              }}
              //   onSelect={handleEmployeeSelect}
              onClear={() => setFilterEmployee([])}
              showClear
              placeholder="Enter Employee code"
              fuseOptions={fuseOptions} // Search on both fields
              className="text-end hover:bg-[#e9ecf1] focus:bg-[#e9ecf1] mb-[-6px]"
              styling={{
                height: "30px",
                border: "1px solid #ced4da",
                borderRadius: "4px",
                backgroundColor: "white",
                boxShadow: "none",
                textAlign: "end",
                hoverBackgroundColor: "lightgray",
                color: "black",
                // marginBottom: "-3px",
                fontSize: "12px",
                fontFamily: "Poppins",
                iconColor: "green",
                clearIconMargin: "3px 8px 0 0",
                zIndex: 10,
              }}
            />
          </Col>

          <Col xs={24} sm={12} md={8} lg={6} xl={6}>
            <div className="mb-2">
              <Typography className="poppins-txt">Department</Typography>
            </div>
            <Select
              placeholder="Select department"
              allowClear
              className="custom-select"
              name="department"
              value={department}
              onChange={(value, options) => {
                if (options) {
                  // normal selection
                  setDepartment({
                    label: options.label,
                    value: value,
                  });
                } else {
                  // cleared selection
                  setDepartment({ label: "", value: "" });
                }
              }}
              options={
                !isEmpty(dropDownList) ? dropDownList.departmentOptions : []
              }
              // options={departmentOptions}
              autoComplete="off"
              dropdownRender={(menu) => (
                <h1 className="option-text-font">{menu}</h1>
              )}
            />
          </Col>
          <Col xs={24} sm={12} md={8} lg={6} xl={6}>
            <div className="mb-2">
              <Typography className="poppins-txt">Designation</Typography>
            </div>
            <Select
              placeholder="Select designation"
              allowClear
              className="custom-select"
              name="designation"
              value={designation}
              onChange={(value, options) => {
                if (options) {
                  // normal selection
                  setDesignation({
                    label: options.label,
                    value: value,
                  });
                } else {
                  // cleared selection
                  setDesignation({ label: "", value: "" });
                }
              }}
              options={designationOptions}
              // options={designationOptions}
              autoComplete="off"
              dropdownRender={(menu) => (
                <h1 className="option-text-font">{menu}</h1>
              )}
            />
          </Col>
          <Col xs={24} sm={12} md={8} lg={6} xl={6}>
            <div>
              <div className="mb-2">
                <Typography className="poppins-txt">From Date</Typography>
              </div>
              <DatePicker
                className="custom-select py-2"
                name="fromDate"
                value={employeeLeaveData.fromDate}
                onChange={(date) => handleDateChange("fromDate", date)}
                maxDate={employeeLeaveData.toDate}
              />
            </div>
          </Col>

          <Col xs={24} sm={12} md={8} lg={6} xl={6}>
            <div>
              <div className="mb-2">
                <Typography className="poppins-txt">To Date</Typography>
              </div>
              <DatePicker
                className="custom-select py-2"
                name="toDate"
                value={employeeLeaveData.toDate}
                onChange={(date) => handleDateChange("toDate", date)}
                minDate={employeeLeaveData.fromDate}
              />
            </div>
          </Col>

          <Col xs={24} sm={12} md={8} lg={6} xl={6}>
            <div className="mb-2">
              <Typography className="poppins-txt">Count</Typography>
            </div>
            <Row gutter={8} align="middle">
              <Col xs={20}>
                <Input
                  placeholder="Enter count"
                  name="count"
                  value={employeeLeaveData.count}
                  onChange={(e) => handleChange(e)}
                  type="text"
                  className="custom-select"
                  autoComplete="off"
                  status={employeeLeaveData.countError ? "error" : ""}
                />
                {employeeLeaveData.countError && (
                  <Typography.Text type="danger" style={{ fontSize: "12px" }}>
                    {employeeLeaveData.countError}
                  </Typography.Text>
                )}
              </Col>
              <Col xs={4}>
                <Button
                  type="primary"
                  icon={<SearchOutlined />}
                  style={{ height: "33px", width: "100%", fontSize: "13px" }}
                  onClick={handleCount}
                />
              </Col>
            </Row>
          </Col>
          <Col xs={24} sm={12} md={8} lg={6} xl={6}>
            <Checkbox
              style={{ marginTop: "25px" }}
              name="inactiveEmployees"
              checked={inactiveEmployees}
              onChange={(e) => handleCheckboxChange(e)}
              className="poppins-txt"
              autoComplete="off"
            >
              Inactive Employee
            </Checkbox>
          </Col>
        </Row>

        <Row justify="end" style={{ marginTop: "8px" }}>
          <Col>
            <Button
              className="custom-btn"
              icon={<ReloadOutlined style={{ fontSize: "16px" }} />}
              size="middle"
              onClick={onReset}
              loading={resetLoading}
              danger
              style={{ marginRight: "12px" }}
            >
              Reset
            </Button>
            <Button
              className="custom-btn"
              type="primary"
              size="middle"
              icon={<FilterOutlined style={{ fontSize: "18px" }} />}
              htmlType="submit"
              onClick={handleFilter}
              loading={searchLoading}
            >
              Apply Filter
            </Button>
          </Col>
        </Row>
      </div>

      <div
        style={{
          background: "#ffffff",
          margin: "20px 8px 15px 8px", // top, right, bottom, left
          padding: "16px",
        }}
      >
        <Row
          justify="space-between"
          align="middle"
          style={{ marginBottom: 16 }}
        >
          <Col>
            <Input
              placeholder="Search..."
              allowClear
              style={{ width: 250, fontFamily: "Poppins" }}
              name="searchInput"
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
              type="text"
              autoComplete="off"
            />

            <Button
              icon={<SearchOutlined />}
              type="primary"
              style={{ marginLeft: 8 }}
              onClick={handleSearch}
            />
          </Col>
          <Col>
            <Button
              className="custom-btn"
              size="medium"
              type="primary"
              icon={<DownloadOutlined />}
              loading={downloadLoader}
              onClick={exportToCsv}
            >
              Download
            </Button>
          </Col>
        </Row>

        <Table
          columns={columns}
          loading={searchLoading}
          dataSource={tableData}
          className="poppins-txt"
          rowKey={(record) => record._id}
          rowClassName={"text-[12px]"}
          pagination={{
            current: currentPage,
            pageSize: pageSize,
            total: totalCount, // make sure you provide total count from API
            showSizeChanger: true,
            pageSizeOptions: ["5", "10", "20", "30"],
            showTotal: (total, range) => `${range[0]}-${range[1]} of ${total}`,
          }}
          sortDirections={["ascend", "descend"]}
          showSorterTooltip={"sorter-icon"}
          scroll={{
            x: 765,
          }}
          onChange={(pagination, filters, sorter) => {
            const { current, pageSize } = pagination;
            setCurrentPage(current); // you can manage currentPage and pageSize in your component state if needed
            setPageSize(pageSize);
            const updatedParams = {
              ...searchValue,
              page: current,
              limit: pageSize,
            };

            setSearchValue(updatedParams);
            specificDispatch(
              reportAction.loadEmployeeLeaveRecord(updatedParams)
            );
          }}
        />

        <Modal
          open={isModalVisible}
          onCancel={handleModalClose}
          title={
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                fontSize: "20px",
              }}
              className="poppins-txt"
            >
              <span>{modalTitle}</span>
            </div>
          }
          // title="Apply Leave"
          className="poppins-txt custom-active-modal"
          centered
          maskClosable={false}
          footer={null}
          width="70vw"
          maxWidth="1200px"
          style={{
            padding: 0,
            marginLeft: windowDimensions.width > 992 ? "220px" : "0",
          }}
        >
          <div className="custom-modal-content">
            <Row gutter={[16, 16]} style={{ marginTop: "2px" }}></Row>
            <Table
              columns={documentColumns.filter((col) => !col.hidden)}
              loading={searchLoading}
              dataSource={documentTable}
              className="poppins-txt"
              rowKey={(record) => record._id}
              rowClassName={"text-[12px]"}
              sortDirections={["ascend"]}
              showSorterTooltip={"sorter-icon"}
              scroll={{
                x: 765,
              }}
            />
          </div>

          {/* Custom footer with cancel and confirm buttons */}
          <div
            className="custom-modal-footer"
            style={{
              borderTop: "1px solid #ccc",
              padding: "10px 16px",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <Button
              className="custom-btn"
              onClick={handleModalClose}
              style={{
                backgroundColor: "#f46a6a",
                color: "#fff",
                border: "none",
                marginRight: "10px",
              }}
            >
              Close
            </Button>
          </div>
          <ToastContainer
            containerId="toast-1"
            position="top-right"
            autoClose={1500}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            style={{
              fontSize: "12px",
            }}
            pauseOnHover
            theme="dark"
          />
        </Modal>
      </div>
    </React.Fragment>
  );
};
//EmployeeLeaveRecord
export default EmployeeLeaveRecord;
